<template>
  <div class="mdl-layout mdl-js-layout mdl-layout--fixed-header">
    <header id="header" class="mdl-layout__header">
      <div class="mdl-layout-icon">
        <i class="material-icons" v-on:click="back()">arrow_back_ios</i>
      </div>          
      <div class="mdl-layout__header-row">
        <span class="mdl-layout-title"></span>
        <div class="mdl-layout-spacer"></div>
      </div>
    </header>
    <main class="mdl-layout__content">
      <div class="page-content">
        <div class="mdl-card mdl-cell mdl-cell--12-col" v-if="message">
          <div class="mdl-card__title2">
            <h4>{{message.title}}</h4>
          </div>
          <div class="mdl-card__supporting-text">

            {{message.body}}


          </div>
        </div>

        <div class="mdl-card mdl-cell mdl-cell--12-col">
          <div class="mdl-card__supporting-text">
            <br>
            <br>
            <button class="mdl-button mdl-js-button mdl-button--raised mdl-button--colored mdl-js-ripple-effect" v-on:click="confirm">
              Estou ciente
            </button>
          </div>
        </div>

      </div>

    </main>
  </div>
</template>
<script>

  import Vue from 'vue'
  import firebase from 'firebase/app'
  import db from './firebaseInit'
  import * as moment from 'moment'
  import localDb from './localDb'

  import 'material-design-lite'

  var _ = require('lodash');

  if(/Android 4\.[0-3]/.test(navigator.appVersion)){
     window.addEventListener("resize", function(){
        if(document.activeElement.tagName=="INPUT" || document.activeElement.tagName=="TEXTAREA"){
           window.setTimeout(function(){
              document.activeElement.scrollIntoViewIfNeeded();
           },0);
        }
     })
  }

  var currentUser = localStorage.getItem('currentUser')
  let operatorRef = db.doc('instances/' + process.env.FSM_ENV + '/people/' + currentUser)

  export default {
    data: function() {
      return {
        tab: 0,
        message: {
          id: 1,
          title: 'Feriado de Finados',
          body: 'Informamos que não haverá expediente no dia 02/11/2018'
        }
      }  
    },
    methods: {
      formatDate: function(date) {
        return moment(date).format('dddd, DD/MM/YYYY')
      },      
      confirm: function() {
        this.$router.push("/inbox")
      },
      back: function() {
        this.$router.go(-1)
      },
      searchMessages: function() {
        if (!/^\s*$/.test(this.search)) {
          let data = this
          data.messages.splice(0, data.visits.length)
          localDb.visits.each(visit => {
            if (visit.description.search(new RegExp(this.search, 'i')) != -1 || visit.real_state_address.search(new RegExp(this.search, 'i')) != -1) {
              data.visits.splice(0, 0, visit)
            }
          })
        } else {
          this.fillDay(this.today)
        }

      }

    }
  }
</script>
<style scoped>
ul {
  margin: 0px;
  list-style-type: none;
  padding: 0px;
}
li {
  margin: 4px 0;
  display: list-item;
  text-align: -webkit-match-parent;
}
.mdl-list__item {
  padding: 0px;
}
.mdl-card__supporting-text {
  padding-top: 0px;
}
.mdl-list__item--two-line {
  height: 56px;
}
.rating_star {
  font-size: 48px;
}
.mdl-card__title2 {
  padding: 16px;
}
h4 {
  margin-top: 0px;
}
h5 {
  margin-bottom: 5px;
}
textarea {
  border: 1px solid grey;
}
.checklist-title {
  margin-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/MessageView.vue